import styled from '@emotion/native';
import { Col } from 'components/base';
import { ToggleButton } from 'design-system';
import { PADDING } from 'design-system/theme';
import { router } from 'expo-router';
import type React from 'react';
import { useCallback } from 'react';
import { strings } from 'strings';

type LinkType = 'MedicalAid' | 'Private';

interface ToggleProps {
  active: LinkType;
}

const ToggleWrapper = styled(Col)(({ theme }) => ({
  backgroundColor: theme.color['base-grey'],
  justifyContent: 'center',
  alignItems: 'center',
  paddingVertical: PADDING.s,
}));

export const NavigationToggle: React.FC<ToggleProps> = ({ active }) => {
  const onChange = useCallback(
    (value: LinkType) => {
      if (value === active) {
        return;
      }

      // Convert to Expo Router navigation
      const routeMap = {
        MedicalAid: '/admin/onboard/medical-aid',
        Private: '/admin/onboard/private',
      };

      router.push(routeMap[value]);
    },
    [active],
  );

  return (
    <ToggleWrapper>
      <Col alignItems="center" justifyContent="center">
        <ToggleButton<LinkType>
          onChange={onChange}
          options={[
            { value: 'MedicalAid', display: strings.FormLabelMedicalAid },
            { value: 'Private', display: strings.FormLabelPrivate },
          ]}
          value={active}
        />
      </Col>
    </ToggleWrapper>
  );
};
